import $ from 'jquery';
import AOS from 'aos';
import pivot from './modules/pivot.js';
import header from './modules/header.js';

// import styleguide from './modules/style-guide.js';
// import accordions from './modules/accordions.js';
// import cards1Slider from './modules/cards1-slider.js';
// import cards2Slider from './modules/cards2-slider.js';
// import logoSlider from './modules/logo-slider.js';
// import cards from './modules/cards.js';
import menu from './modules/menu.js';
// import highlightUnderlines from './modules/highlight-underlines.js';
import fancyapps from './modules/fancyapps.js';
import programWizard from './modules/program-wizard.js';
import userProfileModals from './modules/user-profile-modals.js';
// import localization from './modules/localization.js';
// import mediaSliders from './modules/media-sliders.js';
import scrollTo from './modules/scrollto.js';
// import sliders from './modules/sliders.js';
import stats from './modules/stats.js';
import testimonials from './modules/testimonials.js';
import videoTestimonials from './modules/video-testimonials.js';
// import resourceFilters from './modules/resource-filters.js';
// import tablepressScopeAttr from './modules/tablepress-scope-attr.js';
// import heroNavAriaLabels from './modules/hero-nav-aria-labels.js';
// import pagerFacetActive from './modules/pager-facet-active.js';
// import facetWpResultsAnnouncement from './modules/facetwp-results-announcement.js';

// import svg from './modules/svg.js';

// Make sure that you init the styleguide first.
// styleguide.init();
// accordions.init();
// cards1Slider.init();
// cards2Slider.init();
// logoSlider.init();
// cards.init();
AOS.init();
pivot.init({ selector: '.coming-soon__image' });
header.init();
menu.init();
// highlightUnderlines.init();
// heroNavAriaLabels.init();
fancyapps.init();
programWizard.init();
userProfileModals.init();
// localization.init();
// mediaSliders.init();
scrollTo.init();
// sliders.init();
stats.init();
testimonials.init();
videoTestimonials.init();
// resourceFilters.init();
// tablepressScopeAttr.init();
// pagerFacetActive.init();
// facetWpResultsAnnouncement.init();
// svg.init();
